// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type TargetSkillProfileUserGoalState = 'SAVED' | 'UNSAVED' | 'DISMISSED' | 'DELETED';

export interface TargetSkillProfileUserStatesV1 {
  id: string;
  userId: number;
  targetSkillProfileId: string;
  createdAt: number;
  updatedAt: number;
  state: TargetSkillProfileUserGoalState;
  thirdPartyOrganizationId: string;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface TargetSkillProfileUserStatesV1Connection {
  elements: Array<TargetSkillProfileUserStatesV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface TargetSkillProfileUserStatesV1ByUserAndProgramQuery {
  TargetSkillProfileUserStatesV1: {
    byUserAndProgram: TargetSkillProfileUserStatesV1Connection | null;
  } | null;
}

export interface TargetSkillProfileUserStatesV1ByUserAndProgramQueryVariables {
  userId: string;
  programId: string;
  state?: string | null;
  includes?: string | null;
}

export interface TargetSkillProfileUserStatesV1GetQuery {
  TargetSkillProfileUserStatesV1: {
    get: TargetSkillProfileUserStatesV1Connection | null;
  } | null;
}

export interface TargetSkillProfileUserStatesV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface TargetSkillProfileUserStatesV1MultiGetQuery {
  TargetSkillProfileUserStatesV1: {
    multiGet: TargetSkillProfileUserStatesV1Connection | null;
  } | null;
}

export interface TargetSkillProfileUserStatesV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-link mutations
// ========================================================================

export interface TargetSkillProfileUserStatesV1SetMutation {
  TargetSkillProfileUserStatesV1: {
    set: TargetSkillProfileUserStatesV1Connection | null;
  } | null;
}

export interface TargetSkillProfileUserStatesV1SetMutationVariables {
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class TargetSkillProfileUserStatesV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'targetSkillProfileUserStates.v1' as const;

  declare id: string;

  declare userId: number;

  declare targetSkillProfileId: string;

  declare createdAt: number;

  declare updatedAt: number;

  declare state: TargetSkillProfileUserGoalState;

  declare thirdPartyOrganizationId: string;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<TargetSkillProfileUserStatesV1>) {
    super(params);
  }
}
